import React from 'react';

import { isNil } from 'lodash-es';
import { useIntl } from 'react-intl';

import { IBaseProps } from '@rbi-ctg/frontend';

import { FlagBackground, FlagLabel } from './styled';
import { FlagNumber } from './styled-flag-number';

interface ITimeLeftFlagProps extends IBaseProps {
  days?: number;
  hours?: number;
}

export const TimeLeftFlag: React.FC<ITimeLeftFlagProps> = ({ days, hours }) => {
  const { formatMessage } = useIntl();

  const displayHoursLeft = days === undefined;
  if (!displayHoursLeft && !isNil(days) && days > 7) {
    return null;
  }

  const text = displayHoursLeft ? formatMessage({ id: hours }) : formatMessage({ id: days });

  const numericValue = displayHoursLeft ? hours : days;

  return (
    <FlagBackground>
      <FlagNumber>{numericValue}</FlagNumber>
      <FlagLabel>
        {text}
        <br />
        {formatMessage({ id: 'left' })}
      </FlagLabel>
    </FlagBackground>
  );
};
